import { render, staticRenderFns } from "./NewShippingDetails.vue?vue&type=template&id=2f1da4be&scoped=true"
import script from "./NewShippingDetails.vue?vue&type=script&lang=js"
export * from "./NewShippingDetails.vue?vue&type=script&lang=js"
import style0 from "./NewShippingDetails.vue?vue&type=style&index=0&id=2f1da4be&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1da4be",
  null
  
)

export default component.exports